import { AxiosService } from 'services';
export function GetStoresService(page, text) {

  const endpoint = text ? `store/list?text=${text}&page=${page}` : `store/list?page=${page}`;

  return AxiosService().get(endpoint)
    .then(function (response) {
      return response.data;
    }).catch(function (error) {
      console.log(error);
    });
}
